import React from 'react'
import { view } from 'react-easy-state'

// import { ReactReader } from "react-reader"
// import PDFRenderer from 'components/common/PDFRenderer'
// import InnerHtml from 'components/common/InnerHtml'
import MathJax from 'react-mathjax-preview'

const ePub = window.ePub

class NoteView extends React.Component {

  loadEpub() {
    const { note } = this.props
    console.log('loadEpub: note:', JSON.parse(JSON.stringify(note)))
    if (note.note_type !== "epub") return

    const url = this.props.note.url
    if (!url) return

    const book = ePub(url)
    const rendition = book.renderTo("viewer", {
      manager: "continuous",
      flow: "scrolled",
      width: "100%",
      height: "1500px"
    })
    const displayed = rendition.display()
    console.log("displayed:", displayed)
  }

  componentDidMount() {
    this.loadEpub()
  }

  render() {

    const { note } = this.props
    // const url = "https://gahp.net/wp-content/uploads/2017/09/sample.pdf"

    // console.log('note', note)

    // note.note_type = "epub"
    // note.url = "https://ncert-neetprep.s3.ap-south-1.amazonaws.com/X/Mathematics/jemh101/OEBPS/content.opf"

    if (note.note_type === 'pdf' && RegExp('.pdf$', 'i').test(note.url)) {
      return <object width="70%" height="70%" style={{ width: '80%', height: 'calc(90vh - 10px)' }} data={note.url} type="application/pdf">Loading...</object>
    }

    if (note.note_type === 'epub' && note.url) {
      return (
        <div>
          <div id="viewer"></div>
        </div>
      )
    }

    if (note.note_type === "html" && note.html_content) {
      return (
        <MathJax math={note.html_content} />
      )
    }

    return <div>Unsupported Note Format</div>

  }
}

export default view(NoteView)
